import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { NavigateFunction } from 'react-router-dom';

import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { PARAMETROSSMTP, ParametrosSmtpPagingRes } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { getUrlParamsFetch } from '@/shared';

const { get, post, put } = erpApi();

///* tanSctack query
export const usefetchParametrosSmtp = (params?: GetParametrosSmtpParams) => {
  return useQuery({
    queryKey: ['parametrosSmtp', ...Object.values(params || {})],
    queryFn: async () => {
      return getParametrosSmtp(params);
    },
  });
};
export const useGetParametroSmtp = (id: string) => {
  return useQuery({
    queryKey: ['parametrosSmtp', id],
    queryFn: async () => {
      return getParametroSmtp(id);
    },
  });
};
export const useCreateParametrosSmtp = (
  navigate: NavigateFunction,
  returnUrl: string
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createParametrosSmtp,
    onSuccess: resp => {
      const setAlert = useUiStore.getState().setAlert;

      queryClient.invalidateQueries({ queryKey: ['parametrosSmtp'] });
      resp.status !== 'error' && navigate(returnUrl, { replace: true });

      resp.code === 400 &&
        setAlert(true, resp.message, resp.status);
    },
  });
};
export const useUpdateParametrosSmtp = (
  navigate: NavigateFunction,
  returnUrl: string
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateParametrosSmtp,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['parametrosSmtp'] });
      navigate(returnUrl);
    },
  });
};
///* axios
export type GetParametrosSmtpParams = {
  page?: number;
  page_size?: number;
  host?: string;
  port?: string;
  username?: string;
  password?: string;
  email?: string;
}
export type CreateParametrosSmtpParams = Omit<PARAMETROSSMTP, 'id_parametros_smtp'>;
export type UpdateParametrosSmtpParams = {
  id: number;
  data: Omit<PARAMETROSSMTP, 'id_parametros_smtp'>;
};
export const getParametrosSmtp = async (params?: GetParametrosSmtpParams) => {
  const queryParams = getUrlParamsFetch({ ...params });
  return get<ParametrosSmtpPagingRes>(
    `${urlBackend}api/v1/parametros-smtp/?${queryParams}`,
    true
  );
};
export const getParametroSmtp = async (id: string) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await get<PARAMETROSSMTP>(`${urlBackend}api/v1/parametros-smtp/${id}/`, true);
  res.status === 'error' && setAlert(true, res.message, res.status);
  return res;
};
export const createParametrosSmtp = async (data: CreateParametrosSmtpParams) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await post<PARAMETROSSMTP>(`${urlBackend}api/v1/parametros-smtp/`, data, true);
  setAlert(true, res.message, res.status);
  return res;
};
export const updateParametrosSmtp = async (params: UpdateParametrosSmtpParams) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await put<PARAMETROSSMTP>(
    `${urlBackend}api/v1/parametros-smtp/${params.id}/`,
    params.data,
    true
  );
  setAlert(true, res.message, res.status);
  return res;
};